module.exports = __webpack_public_path__ + "static/media/circo2021_social.12c35105.jpg";